import { create } from 'zustand';
import type { InputId, NodeId } from 'web';

interface FigmaNodeLayerPickerAutoOpenState {
  pendingInputIdByNodeId: Record<string, InputId | undefined>;
  requestAutoOpen: (nodeId: NodeId, inputId: InputId) => void;
  consumeAutoOpen: (nodeId: NodeId, inputId: InputId) => void;
}

export const useFigmaNodeLayerPickerAutoOpenStore = create<FigmaNodeLayerPickerAutoOpenState>((set) => ({
  pendingInputIdByNodeId: {},
  requestAutoOpen: (nodeId, inputId) =>
    set((state) => ({
      pendingInputIdByNodeId: { ...state.pendingInputIdByNodeId, [nodeId]: inputId },
    })),
  consumeAutoOpen: (nodeId, inputId) =>
    set((state) => {
      if (state.pendingInputIdByNodeId[nodeId] !== inputId) return state;

      const pendingInputIdByNodeId = { ...state.pendingInputIdByNodeId };
      delete pendingInputIdByNodeId[nodeId];
      return { pendingInputIdByNodeId };
    }),
}));

export function requestFigmaNodeLayerPickerAutoOpen(nodeId: NodeId, inputId: InputId) {
  useFigmaNodeLayerPickerAutoOpenStore.getState().requestAutoOpen(nodeId, inputId);
}
